package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.ui.EntityComponent
import ai.flowstorm.common.ui.JsonEditor
import ai.flowstorm.studio.model.GeneratedSample
import ai.flowstorm.studio.resources.GeneratedSampleResource
import ai.flowstorm.studio.util.Mapper
import io.kvision.i18n.tr
import io.kvision.panel.SimplePanel
import io.kvision.panel.tabPanel
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.decodeFromDynamic

class GeneratedSampleViewer(val model: GeneratedSampleResource) : SimplePanel(), EntityComponent<GeneratedSample> {
    override var entity: GeneratedSample? = null

    private val mapper by Mapper::instance

    val mainScope = MainScope()
    val panel: SimplePanel = SimplePanel()
    val form = GeneratedSampleForm(model, this)

    private val jsonEditorOptions: JsonEditor.Options = JsonEditor.Options(
        mode = JsonEditor.Mode.TREE,
        modes = listOf(
            JsonEditor.Mode.TEXT,
            JsonEditor.Mode.TREE,
        )
    ) {
        entity!!.input = mapper.decodeFromDynamic(JsonObject.serializer(), it)
        inputEditor.updateData(entity!!.input)
        form.load(entity!!)
    }

    private val inputEditor = JsonEditor(JsonObject.serializer(), jsonEditorOptions)

    private val outputEditor = JsonEditor(JsonObject.serializer(), jsonEditorOptions)

    override fun load(id: Id): GeneratedSample {
        val generatedSample = model.get(id)
        entity = generatedSample
        return load(generatedSample)
    }

    override fun load(entity: GeneratedSample): GeneratedSample {
        inputEditor.setData(entity.input)
        entity.output?.let { outputEditor.setData(it) }
        form.load(entity)
        add(form)
        add(panel)
        mainScope.launch {
            delay(150)
            tabPanel {
                addTab(tr("Input"), inputEditor)
                addTab(tr("Output"), outputEditor)
            }
        }
        return entity
    }
}